import { Component, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../form-controls-core/value-acessor-base';

import { IImage } from 'app/common/models/image.model';
import { IMedias } from 'app/common/models/medias.model';

@Component({
    selector: 'app-form-image-gallery',
    templateUrl: 'form-image-gallery.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FormImageGalleryComponent),
        multi: true
    }]
})
export class FormImageGalleryComponent extends ValueAccessorBase<IMedias> {

    @ViewChild('fileInput') fileInput: any;

    constructor() {
        super();
    }

    addPhoto(e) {
        const fileList: FileList = e.target.files;

        this.ensureValueInstance();

        Array.from((fileList)).forEach((file) => {
            file.convertToBase64(ecodedFile => {
                const image: IImage = {
                    id: null,
                    url: null,
                    body: ecodedFile,
                    filename: file.name,
                    isDefault: this.value.images.length === 0,
                    file: file
                };

                this.value.images.push(image);
            });
        });

        this.fileInput.nativeElement.value = '';
    }

    private ensureValueInstance(): void {
        if (!this.value) {
            this.value = { images: [], videos: [] };
        }
        if (!this.value.images) {
            this.value.images = [];
        }
    }

    addPhotoClick() {
        const event = new MouseEvent('click', { bubbles: true });
        this.fileInput.nativeElement.dispatchEvent(event);
    }

    setDefaultImage(item: IImage) {
        const index = this.value.images.indexOf(item);
        if (index === -1) {
            return;
        } else {
            this.value.images.forEach(i => i.isDefault = false);
            setTimeout(() => this.value.images[index].isDefault = true, 1);
        }
    }

    deleteImage(img: IImage) {
        const index = this.value.images.indexOf(img);
        if (index === -1) {
            return;
        } else {
            setTimeout(() => {
                const wasDefault = this.value.images[index];
                this.value.images.splice(index, 1);
                if (wasDefault && this.value.images.length) {
                    this.setDefaultImage(this.value.images[0]);
                }
            });
        }
    }

    getBackgroundImage(img: IImage) {
        if (img.body) {
            return 'url(' + img.body + ')';
        }
        return 'url(' + img.url + ')';
    }

    isEmpty() {
        return !this.value
            || !this.value.images
            || !this.value.images.length;
    }
}
